export const NotificationSlugs = {
  TENDER_OPPORTUNITIES_UPDATE: 'tender-opportunities.update',
  TENDER_NEW: 'tender.new',
  MARKET_SUMMARY: 'market-summary',
  FOLLOWED_COMPETITOR_TENDER_UPDATED: 'followed-competitor.tender-update',
  OPPORTUNITY_SUMMARY: 'opportunity.summary',
  OPPORTUNITY_ASSIGNATIONS: 'opportunity-assignations',
  OPPORTUNITY_VOTE_INVITATION: 'opportunity-vote-invitation',
  // The go/no-go's vote events (aloha-documents' GoNoGoNotifications), one type per audience and message
  OPPORTUNITY_VOTE_CAST: 'opportunity.vote.cast', // to the inviter: their invitee has voted
  OPPORTUNITY_VOTE_CHANGED: 'opportunity.vote.changed', // to the inviter: their invitee changed their choice or reasons
  OPPORTUNITY_VOTE_WITHDRAWN: 'opportunity.vote.withdrawn', // to the inviter: the vote was taken back or the invitation declined
  OPPORTUNITY_VOTE_CONFIRMED: 'opportunity.vote.confirmed', // to the voter: their vote as recorded
  OPPORTUNITY_VOTE_COMPLETED: 'opportunity.vote.completed', // to the owner and assignees: every vote is in
  OPPORTUNITY_VOTE_DECIDED: 'opportunity.vote.decided', // to everyone involved: the final decision is made
  OPPORTUNITY_VOTE_REDECIDED: 'opportunity.vote.redecided', // to everyone involved: the final decision changed
  OPPORTUNITY_VOTE_REOPENED: 'opportunity.vote.reopened', // to everyone involved: the final decision was removed
  TENDER_ASSIGNATIONS: 'tender-assignations', // a user was assigned to a tender (inbox assignations)
};

export const NotificationSubjectTypes = {
  TENDER: 'tender',
  OPPORTUNITY: 'opportunity',
};

export const MarketSummarySections = {
  NEW_TENDERS: 'newTenders',
  CHANGED_TENDERS: 'changedTenders',
  COMPETITOR_TENDERS: 'competitorTenders',
};
